import React from "react";
import { Modal, ModalBody } from "reactstrap";

/**
 * Reusable Error Modal component
 */
const ErrorModal = ({
  isOpen,
  message,
  email,
  phone,
  showContactInfo = true,
  onLogout,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      className="modal-dialog-centered account-deactivate-modal"
      size="md"
      modalClassName="custom-modal"
    >
      <ModalBody>
        <div className="text-center">
          <h4 className="title">{message}</h4>
          {showContactInfo && (
            <p>
              Email : {email} <br /> Phone : {phone}
            </p>
          )}
          <button
            className="button button-round button-shadow button-min-130"
            onClick={onLogout}
          >
            Logout
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ErrorModal;
